function syncRange(el: HTMLInputElement) {
  const min = parseFloat(el.min) || 0;
  const max = parseFloat(el.max) || 100;
  const val = parseFloat(el.value);
  const pct = max === min ? 0 : ((val - min) / (max - min)) * 100;
  el.style.setProperty('--range-pct', `${pct}%`);
}

export function initRangeSync() {
  document.querySelectorAll<HTMLInputElement>('input[type="range"]').forEach(syncRange);

  document.addEventListener('input', (e) => {
    const t = e.target;
    if (t instanceof HTMLInputElement && t.type === 'range') syncRange(t);
  }, true);

  new MutationObserver((mutations) => {
    for (const m of mutations) {
      m.addedNodes.forEach((node) => {
        if (node instanceof HTMLInputElement && node.type === 'range') {
          syncRange(node);
        } else if (node instanceof Element) {
          node.querySelectorAll<HTMLInputElement>('input[type="range"]').forEach(syncRange);
        }
      });
    }
  }).observe(document.body, { childList: true, subtree: true });
}
